import API from '@/models/API';

export default class CatalogManagement {
  constructor(item = {}) {
    this.gift_id = item.gift_id || null;
    this.supplier_store_id = item.supplier_store_id || null;
    this.gift_category_id = item.gift_category_id || null;
    this.gift_type_id = item.gift_type_id || null;
    this.title = item.title || '';
    this.description = item.description || '';
    this.points = item.points === 0 || item.points ? item.points : null;
    this.printed_catalog_code = item.printed_catalog_code || '';
    this.product_code = item.product_code || '';
    this.show_on_catalog = item.show_on_catalog || false;
    this.cost = item.cost === 0 || item.cost ? item.cost : '';
    this.cost_type = item.cost_type || '';
    // this.has_synergies = !!item.synergies && !!item.synergies.length;
    this.synergies = item.synergies || [];
    // this.redeem_company_ids = [];
    this.image = item.image || null;
    this.redeem_stores = item.redeem_stores || [];
    this.store_point_title_id =
      (item.store_point_title && item.store_point_title.store_point_title_id) || null;
    this.loyalty_program_ids = item.loyalty_program_ids || [];
  }

  static get = (query) => API.get(`/companies/${localStorage.getItem('storeId')}/gifts${query}`);

  static getCategories = () =>
    API.get(`/common/companies/${localStorage.getItem('storeId')}/gift-categories`);

  static getGift = (id) => API.get(`/companies/${localStorage.getItem('storeId')}/gifts/${id}`);

  static getGiftTypes = () => API.get(`/common/gift-types`);

  static getSuppliers = () => API.get(`/companies/${localStorage.getItem('storeId')}/suppliers`);

  static create = (body) => API.post(`/companies/${localStorage.getItem('storeId')}/gifts`, body);

  static update = (id, body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/gifts/${id}`, body);

  static delete = (id) => API.delete(`/companies/${localStorage.getItem('storeId')}/gifts/${id}`);

  static uploadImage = (id, image) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/gifts/${id}/images`, image);
  static getSynergies = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/synergies/all`);
}
